import { THomeGroupRole } from "src/data/homeGroups/types/homeGroupTypes"
import { THomeRole } from "src/data/homes/types/homeTypes"
import { TOrganizationRole } from "src/data/organizations/types/organizationMemberTypes"
import { useTranslate } from "src/i18n/useTranslate"
import { Combobox } from "src/ui/Combobox/Combobox"

export interface IRoleOption<RoleType> {
  label: string
  description: string
  role: RoleType
  hidden?: boolean
}

export interface IMemberRolePickerProps<RoleType> {
  disabled?: boolean
  required?: boolean
  value: RoleType | undefined
  onChange: (role: RoleType) => void | Promise<void>
  inline?: boolean
  options: IRoleOption<RoleType>[]
  roleFilter?: (role: RoleType) => boolean
}

export function MemberRolePicker<
  RoleType extends THomeRole | TOrganizationRole | THomeGroupRole,
>({
  value: role,
  disabled,
  required,
  inline,
  options,
  onChange,
  roleFilter = Boolean, // default to no filter
}: IMemberRolePickerProps<RoleType>) {
  const { _t, langKeys } = useTranslate()

  const selectedOption = options.find((o) => o.role === role)

  return (
    <Combobox
      input={selectedOption ? _t(selectedOption.label) : ""}
      label={
        !inline ? _t(langKeys.organizations_organization_role_title) : undefined
      }
      selectedValue={role ?? ""}
      onChange={(value) => onChange(value as RoleType)}
      options={options
        .filter((o) => roleFilter(o.role))
        .filter((o) => !o.hidden || selectedOption?.role === o.role)
        .map((o) => ({
          label: _t(o.label),
          value: o.role,
          description: _t(o.description),
        }))}
      onInput={() => {}}
      disabled={disabled}
      required={required}
    />
  )
}
